import { eventChannel } from "redux-saga";
import { call, put, select } from "redux-saga/effects";

import pushWithLng from "./pushWithLng";
import * as s from "../selectors";
import * as actions from "../constants/actions";
import firebase from "../services/firebase";

export function createAuthChannel() {
  return new eventChannel(emit => {
    return firebase.auth.onChange((user = {}) => {
      user = user || {};
      emit({ uid: user.uid });
    });
  });
}

export function* signup({ payload }) {
  const { values, resolve, reject } = payload;
  const { error } = yield call(firebase.auth.signup, values);
  const lng = yield select(s.getLocaleLng);

  if (error) {
    reject(error);
  } else {
    resolve();
    yield put(actions.closeModal());
    yield put(actions.showUIHeader());
    yield put(pushWithLng("/account", lng, true));
  }
}

export function* signin({ payload }) {
  const { values, resolve, reject } = payload;
  const { email = "", password = "" } = values;
  const lng = yield select(s.getLocaleLng);

  const { error } = yield call(firebase.auth.signin, { email, password });

  if (error) {
    reject(error);
  } else {
    resolve();
    yield put(actions.closeModal());
    yield put(actions.showUIHeader());
    yield put(pushWithLng("/account", lng, true));
  }
}

export function* securitySignin({ payload }) {
  const { values, resolve, reject } = payload;
  const { email = "", password = "" } = values;

  const { error } = yield call(firebase.auth.signin, { email, password });

  if (error) {
    reject(error);
  } else {
    yield put(actions.closeModal());
    resolve();
  }
}

export function* signout() {
  const lng = yield select(s.getLocaleLng);

  yield call(firebase.auth.signout);
  yield put(actions.closeUIRightSidebar());
  yield put(pushWithLng("/", lng, true));
}

export function* resetPassword({ payload }) {
  const { values, resolve, reject } = payload;
  const { email = "" } = values;

  const { error } = yield call(firebase.auth.resetPassword, { email });

  if (error) {
    reject(error);
  } else {
    yield put(actions.closeModal());
    resolve();
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js